import { useEffect, useMemo } from "react";

const useDistributionHistogramModal = ({ openModal, distribution }) => {
  useEffect(() => {
    document.body.style.overflow = openModal ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openModal]);

  const metricLabel = distribution?.metricLabel || "Value";

  const histogramData = useMemo(
    () => (distribution?.values || []).map((value) => ({ [metricLabel]: value })),
    [distribution, metricLabel]
  );

  // Caller may supply a custom heading, otherwise default to the median summary
  const summary = distribution?.summary || `Median ${metricLabel}: ${distribution?.median ?? 0}`;

  return { histogramData, metricLabel, summary };
};

export default useDistributionHistogramModal;
